var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { OnDestroy } from '@angular/core';
import { DexieService } from "./dexie.service";
import { UnsubscribeOnDestroy } from "../../unsubscribe-on-destroy";
import * as moment from "moment";
import * as i0 from "@angular/core";
import * as i1 from "./dexie.service";
var LocalDbService = /** @class */ (function (_super) {
    __extends(LocalDbService, _super);
    function LocalDbService(dexieService) {
        var _this = _super.call(this) || this;
        _this.dexieService = dexieService;
        return _this;
    }
    LocalDbService.prototype.between = function (tableName, orderBy, start, end) {
        return __awaiter(this, void 0, void 0, function () {
            var where, collection;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(!start && !end)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.list(tableName, null, orderBy)];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2:
                        where = this.dexieService.table(tableName).where(orderBy);
                        if (!start) {
                            collection = where.below(end);
                        }
                        else if (!end) {
                            collection = where.above(start);
                        }
                        else {
                            collection = where.between(start, end, false, true);
                        }
                        return [4 /*yield*/, collection.filter(function (m) { return !m.deleted; }).toArray()];
                    case 3: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    LocalDbService.prototype.bulkPut = function (tableName, values) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (values.some(function (value) { return !value.$id; })) {
                            throw new Error("Attempt to save to table " + tableName + " without $id");
                        }
                        return [4 /*yield*/, this.dexieService.table(tableName).bulkPut(values)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    LocalDbService.prototype.bulkRemove = function (tableName, ids) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.dexieService.table(tableName).bulkDelete(ids)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    LocalDbService.prototype.clear = function (tableName) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.dexieService.table(tableName).clear()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    LocalDbService.prototype.delete = function (tableName, id) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.update(tableName, { $id: id, deleted: moment().unix() })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    LocalDbService.prototype.exists = function (tableName, key) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, !!this.get(tableName, key)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    LocalDbService.prototype.first = function (tableName, orderBy, filter) {
        return __awaiter(this, void 0, void 0, function () {
            var result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!!filter) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.dexieService.table(tableName).orderBy(orderBy).filter(function (m) { return !m.deleted; }).first()];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2: return [4 /*yield*/, this.list(tableName, filter, orderBy)];
                    case 3:
                        result = _a.sent();
                        if (!result || result.length == 0) {
                            return [2 /*return*/, null];
                        }
                        return [2 /*return*/, result[0]];
                }
            });
        });
    };
    LocalDbService.prototype.get = function (tableName, id) {
        return __awaiter(this, void 0, void 0, function () {
            var model;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!id) {
                            throw new Error("Cannot lookup by empty key for table " + tableName);
                        }
                        return [4 /*yield*/, this.dexieService.table(tableName).get(id)];
                    case 1:
                        model = _a.sent();
                        if (!!model && !!model.deleted) {
                            return [2 /*return*/, null];
                        }
                        return [2 /*return*/, model];
                }
            });
        });
    };
    LocalDbService.prototype.last = function (tableName, orderBy, filter) {
        return __awaiter(this, void 0, void 0, function () {
            var result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!!filter) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.dexieService.table(tableName).orderBy(orderBy).filter(function (m) { return !m.deleted; }).last()];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2: return [4 /*yield*/, this.list(tableName, filter, orderBy)];
                    case 3:
                        result = _a.sent();
                        if (!result || result.length == 0) {
                            return [2 /*return*/, null];
                        }
                        return [2 /*return*/, result[result.length - 1]];
                }
            });
        });
    };
    LocalDbService.prototype.list = function (tableName, filter, orderBy, includeDeleted) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(!filter && !orderBy)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.dexieService.table(tableName).filter(function (m) { return (includeDeleted || !m.deleted); }).toArray()];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2:
                        if (!!orderBy) return [3 /*break*/, 4];
                        return [4 /*yield*/, this.dexieService.table(tableName).where(filter).filter(function (m) { return (includeDeleted || !m.deleted); }).toArray()];
                    case 3: return [2 /*return*/, _a.sent()];
                    case 4:
                        if (!!filter) return [3 /*break*/, 6];
                        return [4 /*yield*/, this.dexieService.table(tableName).orderBy(orderBy).filter(function (m) { return (includeDeleted || !m.deleted); }).toArray()];
                    case 5: return [2 /*return*/, _a.sent()];
                    case 6: return [4 /*yield*/, this.dexieService.table(tableName).where(filter).filter(function (m) { return !!m[orderBy] && (includeDeleted || !m.deleted); }).sortBy(orderBy)];
                    case 7: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    LocalDbService.prototype.listSortFirst = function (tableName, filter, orderBy) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.dexieService.table(tableName).orderBy(orderBy).filter(function (m) { return filter(m) && !m.deleted; }).toArray()];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    LocalDbService.prototype.put = function (tableName, value) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!value.$id) {
                            throw new Error("Attempt to save to table " + tableName + " without $id");
                        }
                        return [4 /*yield*/, this.dexieService.table(tableName).put(value)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    LocalDbService.prototype.remove = function (tableName, id) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.dexieService.table(tableName).delete(id)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    LocalDbService.prototype.update = function (tableName, partial) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!partial.$id) {
                            throw new Error("Attempt to save to table " + tableName + " without $id");
                        }
                        return [4 /*yield*/, this.dexieService.table(tableName).update(partial.$id, partial)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    LocalDbService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function LocalDbService_Factory() { return new LocalDbService(i0.ɵɵinject(i1.DexieService)); }, token: LocalDbService, providedIn: "root" });
    return LocalDbService;
}(UnsubscribeOnDestroy));
export { LocalDbService };
